import { MouseEvent } from "react";
import styles from "../ourCars.module.css";
import { CarTileProps } from "../types";
import { useAppDispatch } from "../../../../../../redux/hooks";
import { publishModalData, publishModalVisibility } from "../../../../../../redux/features/modal/modalSlice";
import PrizeTicketSelector from "../../../../../../components/PrizeTicketSelector/prizeTicketSelector";

const CarTile = ({
  make,
  model,
  cashText,
  carImageSource,
  logoImageSource,
  saleTicketPrice,
  baseTicketPrice,
  isInstantWinActive,
  prizeId,
  hideCashAlternative,
}: CarTileProps) => {
  const dispatch = useAppDispatch();

  const onCarCartClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    dispatch(
      publishModalData({
        modalData: (
          <PrizeTicketSelector
            {...{
              prizeId,
            }}
          />
        ),
      })
    );
    dispatch(publishModalVisibility({ isOpen: true }));
  };
  return (
    <div className={`bg-white ${styles.cardTile} xs:h-[270px] md:h-[290px] relative`}>
      <h1 className={`${styles.cardTitle} text-[#696971]`}>{make}</h1>
      <h2 className={`${styles.cardSubtitle} text-[#a2a2a2] mt-1`}>{model}</h2>
      <hr />
      <p className={`${styles.cardText} mt-2 ${cashText === null ? "invisible" : "visible"}`}>
        Or take <b>{cashText}</b> cash
      </p>
      <div className="flex relative mt-3">
        {logoImageSource && (
          <img src={logoImageSource} alt="logo" className="max-w-[120px] max-h-[70px] absolute bottom-0 pb-[.75rem]" />
        )}
        <img
          className={
            logoImageSource
              ? `${styles.featuredCarImage} ml-auto md:mr-16 xs:mr-0 xs:max-w-[190px] md:max-w-[250px]`
              : styles.carImage
          }
          src={carImageSource}
          alt={`${make}-${model}`}
        />
      </div>
      <div className="absolute bottom-3 left-3 right-3">
        <div className={`flex flex-col ${styles.smView}`}>
          {isInstantWinActive && (
            <div className="flex items-center">
              <svg width="11" height="22" viewBox="0 0 11 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.9635 8.14687C10.9049 8.02031 10.7842 7.93968 10.6515 7.93781L6.4038 7.88118L8.34005 0.47556C8.38611 0.300061 8.30669 0.114813 8.15175 0.0366259C7.99716 -0.0419359 7.81169 0.00925113 7.71234 0.157937L0.0651046 11.5953C-0.0113077 11.7097 -0.0211901 11.8599 0.0393397 11.9844C0.100046 12.1091 0.220929 12.1875 0.35293 12.1875H3.64078L0.956641 21.5153C0.906523 21.6897 0.9817 21.8772 1.1347 21.9595C1.18552 21.9869 1.24023 22 1.29405 22C1.40241 22 1.50847 21.9469 1.57712 21.8493L10.9301 8.53687C11.0094 8.42418 11.0222 8.27324 10.9635 8.14687Z"
                  fill="#FF8200"
                />
              </svg>
              <div className="flex flex-col ml-2">
                <span className="text-[#696971] text-[13.5px]">Qualifies for</span>
                <span className="text-[#ff8200] text-[13.5px] leading-none">Instant Win</span>
              </div>
            </div>
          )}
          <div className="flex items-center">
            <span className={`${styles.saleTicketPrice} text-[#4c4c52] font-medium`}>{saleTicketPrice}</span>
            <span
              className={`${styles.baseTicketPrice} ${saleTicketPrice ? "line-through text-[#97979f]" : "text-[#4c4c52] font-medium"}`}>
              {baseTicketPrice}
            </span>
            <button className={`ml-auto ${styles.cartButton} p-[5px]`} onClick={onCarCartClick}>
              <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.00065 14.5671C5.44268 14.5671 5.8666 14.7427 6.17916 15.0552C6.49172 15.3678 6.66732 15.7917 6.66732 16.2337C6.66732 16.6758 6.49172 17.0997 6.17916 17.4122C5.8666 17.7248 5.44268 17.9004 5.00065 17.9004C4.55862 17.9004 4.1347 17.7248 3.82214 17.4122C3.50958 17.0997 3.33398 16.6758 3.33398 16.2337C3.33398 15.7917 3.50958 15.3678 3.82214 15.0552C4.1347 14.7427 4.55862 14.5671 5.00065 14.5671ZM5.00065 14.5671H14.1673M5.00065 14.5671V2.90039H3.33398M14.1673 14.5671C14.6093 14.5671 15.0333 14.7427 15.3458 15.0552C15.6584 15.3678 15.834 15.7917 15.834 16.2337C15.834 16.6758 15.6584 17.0997 15.3458 17.4122C15.0333 17.7248 14.6093 17.9004 14.1673 17.9004C13.7253 17.9004 13.3014 17.7248 12.9888 17.4122C12.6762 17.0997 12.5007 16.6758 12.5007 16.2337C12.5007 15.7917 12.6762 15.3678 12.9888 15.0552C13.3014 14.7427 13.7253 14.5671 14.1673 14.5671ZM5.00065 4.56706L16.6673 5.40039L15.834 11.2337H5.00065"
                  stroke="#F7F7F7"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
        <div className={`flex ${styles.lgView}`}>
          <span className={`${styles.saleTicketPrice} text-[#4c4c52] font-medium`}>{saleTicketPrice}</span>
          <span
            className={`${styles.baseTicketPrice} ${saleTicketPrice ? "line-through text-[#97979f]" : "text-[#4c4c52] font-medium"}`}>
            {baseTicketPrice}
          </span>
          <div className="flex items-center ml-auto">
            {isInstantWinActive && (
              <>
                <svg width="11" height="22" viewBox="0 0 11 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.9635 8.14687C10.9049 8.02031 10.7842 7.93968 10.6515 7.93781L6.4038 7.88118L8.34005 0.47556C8.38611 0.300061 8.30669 0.114813 8.15175 0.0366259C7.99716 -0.0419359 7.81169 0.00925113 7.71234 0.157937L0.0651046 11.5953C-0.0113077 11.7097 -0.0211901 11.8599 0.0393397 11.9844C0.100046 12.1091 0.220929 12.1875 0.35293 12.1875H3.64078L0.956641 21.5153C0.906523 21.6897 0.9817 21.8772 1.1347 21.9595C1.18552 21.9869 1.24023 22 1.29405 22C1.40241 22 1.50847 21.9469 1.57712 21.8493L10.9301 8.53687C11.0094 8.42418 11.0222 8.27324 10.9635 8.14687Z"
                    fill="#FF8200"
                  />
                </svg>
                <div className="flex flex-col mx-2">
                  <span className="text-[#696971] text-[13.5px]">Qualifies for</span>
                  <span className="text-[#ff8200] text-[13.5px]">Instant Win</span>
                </div>
              </>
            )}
            <button className={`${styles.cartButton} p-[7px]`} onClick={onCarCartClick}>
              <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.00065 14.5671C5.44268 14.5671 5.8666 14.7427 6.17916 15.0552C6.49172 15.3678 6.66732 15.7917 6.66732 16.2337C6.66732 16.6758 6.49172 17.0997 6.17916 17.4122C5.8666 17.7248 5.44268 17.9004 5.00065 17.9004C4.55862 17.9004 4.1347 17.7248 3.82214 17.4122C3.50958 17.0997 3.33398 16.6758 3.33398 16.2337C3.33398 15.7917 3.50958 15.3678 3.82214 15.0552C4.1347 14.7427 4.55862 14.5671 5.00065 14.5671ZM5.00065 14.5671H14.1673M5.00065 14.5671V2.90039H3.33398M14.1673 14.5671C14.6093 14.5671 15.0333 14.7427 15.3458 15.0552C15.6584 15.3678 15.834 15.7917 15.834 16.2337C15.834 16.6758 15.6584 17.0997 15.3458 17.4122C15.0333 17.7248 14.6093 17.9004 14.1673 17.9004C13.7253 17.9004 13.3014 17.7248 12.9888 17.4122C12.6762 17.0997 12.5007 16.6758 12.5007 16.2337C12.5007 15.7917 12.6762 15.3678 12.9888 15.0552C13.3014 14.7427 13.7253 14.5671 14.1673 14.5671ZM5.00065 4.56706L16.6673 5.40039L15.834 11.2337H5.00065"
                  stroke="#F7F7F7"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarTile;
